import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import { checkSystemActivityPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
const moment = require('moment');

export class ActivityLogs extends Component {
  state = {
    eventTypeFilter: '',
    fromDate: '',
    toDate: '',
    usernameFilter: '',
    currentPage: 1,
    perPage: 25,
  };

  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getAllTrackingActivity({ version, projectId });
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value, currentPage: 1 });
  };

  handleInputChange = (key, event) => {
    this.handleChange(key, event.target.value);
  };

  resetFilters = () => {
    this.setState({
      eventTypeFilter: '',
      fromDate: '',
      toDate: '',
      usernameFilter: '',
      currentPage: 1,
    });
  };

  filterActivities = (allActivity, eventTypeFilter, fromDate, toDate, usernameFilter) => {
    return allActivity.filter((activity) => {
      const activityDate = new Date(activity.createdAt);
      if (eventTypeFilter && activity.eventType.toUpperCase() !== eventTypeFilter.toUpperCase()) {
        return false;
      }
      if (fromDate && activityDate < new Date(fromDate)) {
        return false;
      }
      if (toDate && activityDate > new Date(toDate)) {
        return false;
      }

      if (usernameFilter && activity.user.username !== usernameFilter) {
        return false;
      }
      return true;
    });
  };

  handlePageChange = ({ selected }) => {
    this.setState({ currentPage: selected + 1 });
  };

  render() {
    const isAllowed = checkSystemActivityPermission();
    if (!isAllowed) {
      return <PermissionDenied message="System activity" />;
    }

    const { eventTypeFilter, fromDate, toDate, usernameFilter, currentPage, perPage } = this.state;
    const { allActivity, projectDetail } = this.props.appSetting;
    const eventTypes = [
      ...new Set(allActivity.map((activity) => activity.eventType.toUpperCase())),
    ];
    const eventOptions = eventTypes.map((eventType) => ({ label: eventType, value: eventType }));
    const usernames = [...new Set(allActivity.map((activity) => activity.user.username))];
    const filteredActivity = this.filterActivities(
      allActivity,
      eventTypeFilter,
      fromDate,
      toDate,
      usernameFilter,
    );
    const isFilterActive = eventTypeFilter || fromDate || toDate || usernameFilter;
    const offset = (currentPage - 1) * perPage;
    const paginatedActivity = filteredActivity.slice(offset, offset + perPage);
    const totalPages = Math.ceil(filteredActivity.length / perPage);
    if (!projectDetail) {
      return '';
    }

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'system-activity'} projectDetail={projectDetail} />
        <ParentContentCard title="System activity" icon="system-activity">
          <div className="row">
            <div className="col-sm">Event Type:</div>
            <div className="col-sm-2">
              <CustomSelect
                name={'eventTypeFilter'}
                isMulti={false}
                options={eventOptions}
                value={eventTypeFilter}
                onChange={(name, value) => this.handleChange(name, value)}
                placeholder={'Choose Events'}
              />
            </div>
            <div className="col-sm">From Date:</div>
            <div className="col-sm">
              <input
                type="date"
                value={fromDate}
                onChange={(event) => this.handleInputChange('fromDate', event)}
                className="formik "
              />
            </div>
            <div className="col-sm">To Date:</div>
            <div className="col-sm">
              <input
                type="date"
                value={toDate}
                onChange={(event) => this.handleInputChange('toDate', event)}
                className="formik "
              />
            </div>
            <div className="col-sm">
              <label htmlFor="usernameFilter">Username:</label>
            </div>

            <div className="col-sm-2">
              <CustomSelect
                name={'usernameFilter'}
                isMulti={false}
                options={usernames.map((usernames) => ({ label: usernames, value: usernames }))}
                value={usernameFilter}
                onChange={(name, value) => this.handleChange(name, value)}
                placeholder={'Choose Username'}
              />
            </div>
            <div className="col-sm">
              <button className="btn" onClick={this.resetFilters} disabled={!isFilterActive}>
                <i className="wb webconnect-refresh"></i> Reset Filter
              </button>
            </div>
          </div>
          <table className="table table-bordered table-striped table-responsive-sm text-center p-3 m-3">
            <tbody>
              <tr>
                <th>Username</th>
                <th>Name</th>
                <th>EventType</th>
                <th>Ip</th>
                <th>Time</th>
                <th>EventDetails</th>
              </tr>
              {paginatedActivity.map((activity) => {
                const createdAt = new Date(activity.createdAt);
                const formattedTime = moment(createdAt).format('Do MMMM YYYY, h:mm a');
                const { _id, user, eventDetails, eventType, ip } = activity;
                return (
                  <tr key={_id}>
                    <td>{user.username}</td>
                    <td>{user.name}</td>
                    <td>{eventType}</td>
                    <td>{ip}</td>
                    <td>{formattedTime}</td>
                    <td>{eventDetails}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {paginatedActivity > perPage && (
            <CustomReactPaginate
              totalPages={totalPages}
              page={currentPage - 1}
              onPageChange={this.handlePageChange}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
            />
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogs);
